"use strict";

exports.__esModule = true;
exports.ResizeDirection = exports.ContentResizeDirection = void 0;
let ResizeDirection = exports.ResizeDirection = /*#__PURE__*/function (ResizeDirection) {
  ResizeDirection["horizontal"] = "horizontal";
  /** Component can only be resized vertically */
  ResizeDirection["vertical"] = "vertical";
  /** Component can be resized both horizontally and vertically */
  ResizeDirection["horizontalAndVertical"] = "horizontalAndVertical";
  /** Component maintains its aspect ratio while resizing */
  ResizeDirection["aspectRatio"] = "aspectRatio";
  /** Component cannot be resized in any direction */
  ResizeDirection["none"] = "none";
  return ResizeDirection;
}({});
;
let ContentResizeDirection = exports.ContentResizeDirection = /*#__PURE__*/function (ContentResizeDirection) {
  /** Component's width will automatically adjust based on its content */
  ContentResizeDirection["horizontal"] = "horizontal";
  /** Component's height will automatically adjust based on its content */
  ContentResizeDirection["vertical"] = "vertical";
  /** Component's width and height will automatically adjust based on its content */
  ContentResizeDirection["horizontalAndVertical"] = "horizontalAndVertical";
  /** Component's size will not be affected by its content */
  ContentResizeDirection["none"] = "none";
  return ContentResizeDirection;
}({});
;
//# sourceMappingURL=layout.js.map